// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import BulkDeleteQuoteController from "./bulk_delete_quote_controller"
application.register("bulk-delete-quote", BulkDeleteQuoteController)

import CheckBoxController from "./check_box_controller"
application.register("check-box", CheckBoxController)

import OrderTableController from "./order_table_controller"
application.register("order-table", OrderTableController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import UserFormController from "./user_form_controller"
application.register("user-form", UserFormController)
